import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditProductVisibility from '../edit/EditProductVisibility';
import DialogBase from './DialogBase';
import { DialogContent, DialogTitle } from '@mui/material';

class DialogEditProductVisibility extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-product-visibility";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Distribution du produit</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditProductVisibility
            scrollableTarget={scrollableTargetId}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditProductVisibility.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditProductVisibility);
